import {MenuItem, Select, makeStyles} from '@material-ui/core';
import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ActionButton} from '@dishtech-react/core';
import {ChevronLeft, ChevronRight} from '@material-ui/icons';
import {AVAIL_ENDPOINT, AVAIL_ERRORS_ENDPOINT, limitParamsOptions} from '../../../../helpers/constants';
import {changePageLimitSize, findIncomingPageResults} from '../../../../redux/actions/results-actions';

const useStyles = makeStyles(theme => ({
  pageControls: {
    display: 'flex',
    gap: theme.spacing(0.5),
    alignItems: 'center',
  },

  foundResultsInfo: {
    display: 'flex',
  },
  tableControlsHeader: {
    background: 'lightgray',
    padding: theme.spacing(0.5),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
}));

const ResultsHeader = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {results, total, endpoint, searchType, params} = useSelector(state => state?.results);
  const {page, limit: pageLimit} = params;
  const maxPages = Math.ceil(+total / +params.limit);
  const canGoBackPage = page > 0;
  const canGoNextPage = maxPages > page + 1;

  const searchTypeTitle = AVAIL_ENDPOINT === endpoint ? 'Avail' : AVAIL_ERRORS_ENDPOINT === endpoint ? 'Error' : '';

  const handlePrevPageNavigation = () => {
    if (!canGoBackPage) return;

    dispatch(findIncomingPageResults(page - 1));
  };

  const handleNextPageNavigation = () => {
    if (!canGoNextPage) return;

    dispatch(findIncomingPageResults(page + 1));
  };

  const handleLimitChange = evt => {
    dispatch(changePageLimitSize(evt.target.value));
  };

  const resolveSearchMessage = () => {
    const endpointText = endpoint === AVAIL_ENDPOINT ? 'avails' : 'errors';

    if (searchType === 'all') {
      return `Searching ALL ${endpointText}`;
    }

    if (searchType === 'price') {
      return `Filtering avails by price term: PRICE: ${params.price}, TYPE: ${params.type}${params.currency &&
        `, CURRENCY: ${params.currency}`}`;
    }

    if (searchType === 'systemseverity') {
      return `Filtering errors by system and/or severity: ${params.system !== '*' ? `SYSTEM: ${params.system}` : ''}
      ${params.severity !== '*' && params.system !== '*' ? ',' : ''} 
      ${params.severity !== '*' ? `SEVERITY: ${params.severity}` : ''}`;
    }

    return `Searching ${endpointText} by ${searchType.toUpperCase()}: ${params[searchType]}`;
  };

  return (
    <div className={classes.tableControlsHeader}>
      <div className={classes.foundResultsInfo}>
        <p>
          <strong>{total}</strong>&nbsp;{`${searchTypeTitle}${total > 1 ? 's' : ''} found`}
        </p>
      </div>
      <div>{resolveSearchMessage()}</div>
      <div className={classes.pageControls}>
        <label htmlFor="asset-table-limit-select-label">Assets per Page:&nbsp;</label>
        <Select
          id="asset-table-limit-select"
          labelId="asset-table-limit-select-label"
          name="limit"
          value={pageLimit}
          onChange={handleLimitChange}
        >
          {limitParamsOptions.map(limitOption => (
            <MenuItem key={limitOption.value} value={limitOption.value}>
              {limitOption.title}
            </MenuItem>
          ))}
        </Select>
        {results.length > 0 && (
          <>
            {' '}
            <span>&nbsp;-&nbsp;</span>
            <p>{`Page ${page + 1} of ${maxPages}`}</p>
            <ActionButton
              disable={!canGoBackPage}
              handleClick={handlePrevPageNavigation}
              icon={ChevronLeft}
              toolTipTitle="Previous Page"
            />
            <ActionButton
              disable={!canGoNextPage}
              handleClick={handleNextPageNavigation}
              icon={ChevronRight}
              toolTipTitle="Next Page"
            />
          </>
        )}
      </div>
    </div>
  );
};

export default ResultsHeader;
